const IMA_NAV_REFERRER_KEY = 'r13_ima_nav_referrer'

export const captureImaNavReferrer = (fromHref: string): void => {
  if (typeof window === 'undefined' || !fromHref) {
    return
  }
  try {
    sessionStorage.setItem(IMA_NAV_REFERRER_KEY, fromHref)
  } catch {
    // sessionStorage may be unavailable
  }
}

/** Page the user came from. Empty string means omit the `ref` param. */
export const resolveImaReferrer = (): string => {
  if (typeof window === 'undefined') {
    return ''
  }

  const current = window.location.origin + window.location.pathname

  if (document.referrer) {
    try {
      const refPath =
        new URL(document.referrer).origin + new URL(document.referrer).pathname
      if (refPath !== current) {
        return document.referrer
      }
    } catch {
      return document.referrer
    }
  }

  try {
    const stored = sessionStorage.getItem(IMA_NAV_REFERRER_KEY)
    if (stored) {
      try {
        const storedPath = new URL(stored).origin + new URL(stored).pathname
        if (storedPath !== current) {
          return stored
        }
      } catch {
        if (stored !== current) {
          return stored
        }
      }
    }
  } catch {
    // ignore
  }

  return ''
}
